export default {
    methods: {
        cnvData: function(recordData,initflg=null) {
            var rec = [];

            if(recordData !== null && initflg === null) {
                rec.id      = recordData.id //'案件ID'

                if(recordData.client!=null) {
                    rec.client_id    =  recordData.client.id // 顧客ID
                    rec.client_text = recordData.client.name
                }
                else {
                    rec.client_id   = null // 顧客ID
                    rec.client_text = ""
                }

                let variableName = "user"

                if(recordData[variableName]!=null) { // 担当者
                    rec[variableName + "_name"] = recordData[variableName].username // 担当者名
                    rec[variableName + "_id"] = recordData[variableName].id // 担当者ID
                    rec[variableName + "_obj"] = {value:String(recordData[variableName].id),label:recordData[variableName].username} // 担当者OBJ
                }
                else {
                    rec[variableName + "_name"] =  "" // 担当者名
                    rec[variableName + "_id"] = null // 担当者ID
                    rec[variableName + "_obj"] = {value:null,label:""} //  // 担当者OBJ
                }

                let variableCaseStatusName = "case_status"

                if(recordData[variableCaseStatusName]!=null) { // 案件ステータス
                    rec[variableCaseStatusName + "_name"] = recordData[variableCaseStatusName].name // 案件ステータス名
                    rec[variableCaseStatusName + "_id"] = recordData[variableCaseStatusName].id // 案件ステータスID
                    rec[variableCaseStatusName + "_obj"] = {value:String(recordData[variableCaseStatusName].id),label:recordData[variableCaseStatusName].name} // 案件ステータスOBJ
                }
                else {
                    rec[variableCaseStatusName + "_name"] =  "" // 案件ステータス名
                    rec[variableCaseStatusName + "_id"] = null // 案件ステータスID
                    rec[variableCaseStatusName + "_obj"] = {value:null,label:""} //  // 案件ステータスOBJ
                }

                if(recordData.startdate != null) {
                    rec.startdate = this.$moment(recordData.startdate).format('YYYY-MM-DD') // 登録日
                }
                else {
                    rec.startdate = ""
                }

                if(recordData.enddate != null) {
                    rec.enddate = this.$moment(recordData.enddate).format('YYYY-MM-DD') // 登録日
                }
                else {
                    rec.enddate = ""
                }

                rec.status_hidden = recordData.status_hidden

                rec.name      = recordData.name //'案件名前'

                rec.work_days = recordData.work_days

                if(recordData.acceptance != null) {
                    rec.acceptance = this.$moment(recordData.acceptance).format('YYYY-MM-DD') //'受付日'
                }
                else {
                    rec.acceptance = this.$moment().format('YYYY-MM-DD')//'受付日'
                }

                if(Object.prototype.hasOwnProperty.call(recordData, 'greenc_job_offer_coverage_hearings') && recordData.greenc_job_offer_coverage_hearings.length>0) {
                    rec.f49      = recordData.greenc_job_offer_coverage_hearings[0].f49
                    rec.f50      = recordData.greenc_job_offer_coverage_hearings[0].f50

                    if(Object.prototype.hasOwnProperty.call(recordData.greenc_job_offer_coverage_hearings[0], 'greenc_mst_corporate') == true) {
                        rec.greenc_mst_corporate_name = recordData.greenc_job_offer_coverage_hearings[0].greenc_mst_corporate.name
                    }
                    else {
                        rec.greenc_mst_corporate_name = ""
                    }
                }
                else {
                    rec.f49      = ""
                    rec.f50      = ""
                    rec.greenc_mst_corporate_name = ""
                }

                rec.sales      = recordData.sales //'売上'

                rec.gross      = recordData.gross //'粗利'

                rec.cost      = recordData.cost //'原価金額'

                rec.tips      = recordData.tips //'注意書きや特記事項記載'

                rec.created      =  this.$moment(recordData.created).format('YYYY-MM-DD') //'レコード生成日'

                rec.modified      = this.$moment(recordData.modified).format('YYYY-MM-DD') //'レコード更新日'

                rec.deleted      = recordData.deleted //'レコード削除日'


            } else {
                rec.id_id   = null //  // <JNAME_PRE>
                rec.id_text = ""

                rec.client_id   = null // 顧客ID
                rec.client_text = ""

                let variableName = "user"

                rec[variableName + "_name"] =  "" // 担当者名
                rec[variableName + "_id"] = null // 担当者ID
                rec[variableName + "_obj"] = {value:null,label:""} //  // 担当者OBJ

                let variableCaseStatusName = "case_status"

                rec[variableCaseStatusName + "_name"] =  "" // 担当者名
                rec[variableCaseStatusName + "_id"] = null // 担当者ID
                rec[variableCaseStatusName + "_obj"] = {value:null,label:""} //  // 担当者OBJ

                rec.name      = "" //'案件名前'

                rec.f49      = ""
                rec.f50      = ""

                rec.startdate = this.$moment().format('YYYY-MM-DD')
                rec.enddate = this.$moment().format('YYYY-MM-DD')


                rec.acceptance_id   = null //  // <JNAME_PRE>
                rec.acceptance_text = ""

                rec.sales_id   = null //  // <JNAME_PRE>
                rec.sales_text = ""

                rec.gross_id   = null //  // <JNAME_PRE>
                rec.gross_text = ""

                rec.cost_id   = null //  // <JNAME_PRE>
                rec.cost_text = ""

                rec.status_hidden = "no"

                rec.greenc_mst_corporate_name = ""

                rec.tips      = "" //'注意書きや特記事項記載'

                rec.created_id   = null //  // <JNAME_PRE>
                rec.created_text = ""

                rec.modified_id   = null //  // <JNAME_PRE>
                rec.modified_text = ""

                rec.deleted_id   = null //  // <JNAME_PRE>
                rec.deleted_text = ""


            }
            return rec
        },
    }
}